import * as React from 'react';
import { ScopeButton } from '@monorepo/shared-lib';
import { Col, Row } from 'antd';
import routes from 'routes';
import i18n from 'i18next';
import { DataLogStatus } from 'store/app/enums';
import { VatRunData } from 'store/vat/models';
import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  margin-top: 10px;

  .error-text {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    color: var(--color-status-danger, #d13131);
  }

  .report-link {
    font-family: Inter;
    font-size: 12px;
    font-weight: 600;
    line-height: 12px;
    text-align: left;
    color: var(--color-status-danger, #d13131);
  }
`;

export const renderErrorMessage = (data: VatRunData) => {
  return (
    <ErrorWrapper>
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          {!data.isPeriodClosed && !data.dataLogId && (
            <>
              <span className="error-text">
                <strong>{i18n.t('vat-report.caution-label')}</strong>{' '}
                {i18n.t(
                  'vat-report.cannot-save-report-another-open-return-for-period'
                )}
              </span>
            </>
          )}
          {data.status !== DataLogStatus.CANCELLED &&
            data.status !== DataLogStatus.SUBMITTED &&
            data.isFirstTime === false &&
            data.validRange !== null &&
            data.validRange === false && (
              <>
                <hr />
                <span className="error-text">
                  <strong>{i18n.t('vat-report.caution-label')}</strong>{' '}
                  {i18n.t(
                    'vat-report.report-cannot-be-saved-updated-or-submitted-date-range-mismatch'
                  )}
                </span>
              </>
            )}
          {data.isFirstTime === true &&
            data.validRange !== null &&
            data.validRange === false &&
            (!data.status || data.status === DataLogStatus.NOT_SAVED) && (
              <>
                <hr />
                <span className="error-text">
                  <strong>{i18n.t('vat-report.caution-label')}</strong>{' '}
                  {i18n.t(
                    'vat-report.chosen-reporting-period-differs-from-mapping'
                  )}
                </span>
              </>
            )}
        </Col>
        {!data.isPeriodClosed && !data.dataLogId && !!data.openDataLogId && (
          <Col span={24}>
            <ScopeButton
              onClick={() => {
                const url = routes.vat.viewReportLink
                  .replace(':connectionId', data.tokenId)
                  .replace(':mappingId', data.mappingId)
                  .replace(':dataLogId', data.openDataLogId);
                document.location = url;
              }}
              type="default"
            >
              {i18n.t('vat-report.view-the-open-return')}
            </ScopeButton>
          </Col>
        )}
      </Row>
    </ErrorWrapper>
  );
};
